<template>
  <svg
    class="custom-icon"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="sadfasdfasdf">
      <g id="Vector">
        <path
          d="M16.7453 7.47819C16.4578 6.8406 15.5422 6.8406 15.2547 7.47819L13.261 11.8991C13.1424 12.1621 12.891 12.3426 12.6013 12.3728L7.73142 12.8809C7.02908 12.9541 6.74615 13.8148 7.27078 14.2822L10.9085 17.5225C11.1249 17.7152 11.2209 18.0073 11.1604 18.289L10.1444 23.0239C9.99787 23.7067 10.7386 24.2387 11.3504 23.8899L15.5923 21.4716C15.8446 21.3278 16.1554 21.3278 16.4077 21.4716L20.6496 23.8899C21.2614 24.2387 22.0021 23.7067 21.8556 23.0239L20.8396 18.289C20.7791 18.0073 20.8751 17.7152 21.0915 17.5225L24.7292 14.2822C25.2539 13.8148 24.9709 12.9541 24.2686 12.8809L19.3987 12.3728C19.109 12.3426 18.8576 12.1621 18.739 11.8991L16.7453 7.47819Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26 2.5H6C4.067 2.5 2.5 4.067 2.5 6V26C2.5 27.933 4.067 29.5 6 29.5H26C27.933 29.5 29.5 27.933 29.5 26V6C29.5 4.067 27.933 2.5 26 2.5ZM6 0C2.68629 0 0 2.68629 0 6V26C0 29.3137 2.68629 32 6 32H26C29.3137 32 32 29.3137 32 26V6C32 2.68629 29.3137 0 26 0H6Z"
        />
      </g>
    </g>
  </svg>
</template>
